import { jwtDecode } from "jwt-decode"
import { Cookies } from "react-cookie";

const cookies = new Cookies();

const GetCurrentUser = () => {
    return jwtDecode(cookies.get("jwt"))
}

export {GetCurrentUser}